import type { ChangeEvent } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { FlexColumn, OnOffSwitch, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import Input from "../../Input/Input";
import { MAX_CHARACTERS_IN_INPUT } from "../constants";

import { TEST_SELECTORS } from "./constants";
import * as SC from "./styles";
import { BODY_TEXT, CHIP_TITLE, INPUT_TITLE, SUBSCRIPTION_TEXT, TITLE, TOOLTIP } from "./texts";

export type NameStepSchema = {
    onNameChange: (name: string) => void;
    errorState: {
        isError: boolean;
        errorMessage: string;
    };
    activationSetName: string;
    shouldSubscribe: boolean;
    onSubscribeToggle: () => void;
};

const NameStep = ({
    onNameChange,
    errorState,
    activationSetName,
    shouldSubscribe,
    onSubscribeToggle,
}: NameStepSchema) => {
    const onChange = (e: ChangeEvent<HTMLInputElement>) => onNameChange(e.target.value);

    return (
        <FlexColumn data-automation={TEST_SELECTORS.nameWrapper}>
            <SC.Title data-automation={TEST_SELECTORS.title}>{translate(TITLE)}</SC.Title>

            <SC.Chip data-automation={TEST_SELECTORS.chip}>{translate(CHIP_TITLE)}</SC.Chip>

            <SC.InputBlockWrapper>
                <SC.InputTitle data-automation={TEST_SELECTORS.inputTitle}>{translate(INPUT_TITLE)}</SC.InputTitle>
                <Input
                    onChange={onChange}
                    isError={errorState.isError}
                    errorMessage={errorState.errorMessage}
                    maxLength={MAX_CHARACTERS_IN_INPUT}
                    value={activationSetName}
                    autoFocus
                />
            </SC.InputBlockWrapper>

            <SC.BodyText data-automation={TEST_SELECTORS.body}>
                {translate(BODY_TEXT)}
                <Tooltip
                    content={translate(TOOLTIP)}
                    data-automation={TEST_SELECTORS.tooltip}
                >
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                        data-automation={TEST_SELECTORS.infoIcon}
                    />
                </Tooltip>
            </SC.BodyText>

            <SC.SwitchWrapper data-automation={TEST_SELECTORS.switcherWrapper}>
                <OnOffSwitch
                    onClick={onSubscribeToggle}
                    isSelected={shouldSubscribe}
                    className="subscriptionSwitch"
                />

                <SC.SwitchLabel data-automation={TEST_SELECTORS.subscriptionText}>
                    {translate(SUBSCRIPTION_TEXT)}
                </SC.SwitchLabel>
            </SC.SwitchWrapper>
        </FlexColumn>
    );
};

export default NameStep;
